module.exports = __webpack_public_path__ + "static/media/checkmark.bdae3f8e.png";